/**
 * Created by elmer on 28/06/17.
 */
import Vue from 'vue';
import Vuex from 'vuex';
import * as loginMutations from '@/modules/login/login.mutations';
import * as loginActions from '@/modules/login/login.actions';
import * as publicidadActions from '@/modules/admin/publicidad.actions';
import * as publicidadMutations from '@/modules/admin/publicidad.mutations';


Vue.use(Vuex);
const jwtToken = localStorage.getItem('jwt') ? JSON.parse(localStorage.getItem('jwt')) : {};
const now = new Date().getTime();

export default new Vuex.Store({
  state: {
    loggedIn: jwtToken.length >= 1 && Object.prototype.hasOwnProperty.call(jwtToken[1], 'token') && Number(jwtToken[1].expires) > now,
    jwt: jwtToken.length >= 1 && Object.prototype.hasOwnProperty.call(jwtToken[1], 'token') && Number(jwtToken[1].expires) > now ? jwtToken[1].token : null,
    user: jwtToken.length >= 1 ? jwtToken[0] : null,
    campaigns: [],
    archivos_publicidad: [],
  },
  mutations: {
    ...loginMutations,
    ...publicidadMutations,
  },
  actions: {
    ...loginActions,
    ...publicidadActions,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js